/**
 * Infrastructure map — static metadata about which repos, workers, and packages
 * are involved in each G1 application. Used by DevInfoOverlay component.
 */
const GITHUB = "https://github.com/TheG1Team";
export const INFRA_MAP = {
    admin: {
        app: "admin",
        label: "G1 Console",
        repo: "g1-platform",
        repoUrl: `${GITHUB}/g1-platform`,
        workers: [
            "g1-shared-api",
            "g1-media-api",
            "spielgeil-media-api",
            "g1-news-media-api",
            "saycasinoname-media-api",
            "g1-templates-api",
        ],
        packages: ["config", "feature-kit", "db", "ui", "analytics", "logger"],
        routeWorkers: {
            "/global-entities": ["g1-global-entities-api", "g1-global-signals-api"],
            "/ab-tests": ["g1-ab-tests-api"],
            "/cloudflare": ["g1-cloudflare-api"],
            "/github": ["g1-github-api"],
            "/staff": ["g1-platform-users-api"],
            "/etl-status": ["g1-etl-worker"],
            "/cio-workspaces": ["g1-cio-workspaces-api"],
        },
    },
    "admin-panel": {
        app: "admin-panel",
        label: "Admin Panel",
        repo: "g1-platform",
        repoUrl: `${GITHUB}/g1-platform`,
        workers: [
            "g1-shared-api",
            "g1-cloudflare-api",
            "g1-github-api",
            "g1-platform-users-api",
            "g1-cio-workspaces-api",
        ],
        packages: ["config", "feature-kit", "db", "ui"],
        routeWorkers: {
            "/ai-models": ["g1-shared-api"],
        },
    },
    web: {
        app: "web",
        label: "Public Site (Astro)",
        repo: "g1-platform",
        repoUrl: `${GITHUB}/g1-platform`,
        workers: ["g1-shared-api"],
        packages: ["config", "schema", "analytics"],
        routeWorkers: {
            "/casino": ["g1-media-api"],
            "/news": ["g1-media-api"],
            "/review": ["g1-media-api"],
        },
    },
    auth: {
        app: "auth",
        label: "Auth Portal",
        repo: "g1-platform",
        repoUrl: `${GITHUB}/g1-platform`,
        workers: ["g1-shared-api"],
        packages: [],
    },
    "affiliates-portal": {
        app: "affiliates-portal",
        label: "Affiliates Portal",
        repo: "g1-affiliates",
        repoUrl: `${GITHUB}/g1-affiliates`,
        workers: ["g1-traffic-api", "g1-go"],
        packages: ["config", "feature-kit", "db"],
    },
    "analytics-web": {
        app: "analytics-web",
        label: "Analytics Dashboard",
        repo: "g1-analytics",
        repoUrl: `${GITHUB}/g1-analytics`,
        workers: ["g1-analytics-api", "g1-analytics-worker", "g1-etl-worker"],
        packages: ["config", "db", "analytics"],
    },
    "delivery-dashboard": {
        app: "delivery-dashboard",
        label: "Delivery Dashboard",
        repo: "g1-delivery",
        repoUrl: `${GITHUB}/g1-delivery`,
        workers: ["g1-delivery-api", "g1-delivery-campaigns-api", "g1-delivery-providers-api"],
        packages: ["config", "ui", "db"],
    },
    "tasks-web": {
        app: "tasks-web",
        label: "Tasks",
        repo: "g1-tasks",
        repoUrl: `${GITHUB}/g1-tasks`,
        workers: ["g1-tasks-api"],
        packages: ["config", "db"],
    },
    games: {
        app: "games",
        label: "G1 Games",
        repo: "g1-games",
        repoUrl: `${GITHUB}/g1-games`,
        workers: ["g1-games"],
        packages: [],
    },
};
export const WORKER_URLS = {
    "g1-shared-api": "https://api.g1.network",
    "g1-media-api": "https://api.g1.reviews",
    "spielgeil-media-api": "https://api.spielgeil.de",
    "g1-news-media-api": "https://api.g1.news",
    "saycasinoname-media-api": "https://api.saycasinoname.com",
    "g1-traffic-api": "https://traffic.g1.network",
    "g1-go": "https://go.g1.network",
    "g1-analytics-api": "https://analytics.g1.network",
    "g1-analytics-worker": "https://analytics-worker.g1.network",
    "g1-etl-worker": "https://etl.g1.network",
    "g1-delivery-api": "https://delivery.g1.network",
    "g1-delivery-campaigns-api": "https://campaigns.delivery.g1.network",
    "g1-delivery-providers-api": "https://providers.delivery.g1.network",
    "g1-tasks-api": "https://tasks-api.g1.network",
    "g1-games": "https://g1.games",
    "g1-templates-api": "https://templates.g1.network",
    "g1-global-entities-api": "https://global-entities.g1.network",
    "g1-global-signals-api": "https://global-signals.g1.network",
    "g1-ab-tests-api": "https://ab-tests.g1.network",
    "g1-cloudflare-api": "https://cf.g1.network",
    "g1-github-api": "https://github-api.g1.network",
    "g1-platform-users-api": "https://users.g1.network",
    "g1-cio-workspaces-api": "https://cio.g1.network",
    "g1-monitoring": "https://monitoring.g1.network",
    "g1-verify": "https://verify.g1.network",
};
//# sourceMappingURL=infra-map.js.map